const productSlider = document.querySelector('.product__info .swiper')

if (productSlider) {
  const productSliderSwiper = new Swiper(productSlider, {
    centerInsufficientSlides: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })

  productSliderSwiper.on('slideChange', (e) => {
    const index = e.activeIndex

    const activeButton = document.querySelector(
      '.product__slider-button--active'
    )
    activeButton.classList.remove('product__slider-button--active')

    const newActiveButton = document.querySelector(
      `.product__slider-button[data-slide="${index}"]`
    )
    newActiveButton.classList.add('product__slider-button--active')
  })

  const productSliderButtons = document.querySelectorAll(
    '.product__slider-button'
  )

  productSliderButtons.forEach((item) => {
    item.addEventListener('click', function () {
      const index = this.getAttribute('data-slide')
      productSliderSwiper.slideTo(index)
    })
  })

  const productZoom = document.querySelectorAll('.product__zoom')
  const productGallery = document.querySelector('.product__gallery')

  const closeGallery = () => {
    productGallery.classList.remove('product__gallery--fullscreen')
    document.body.classList.remove('modal-open')
  }

  const openGallery = () => {
    productGallery.classList.add('product__gallery--fullscreen')
    document.body.classList.add('modal-open')
  }

  productZoom.forEach((item) => {
    item.addEventListener('click', function () {
      if (productGallery.classList.contains('product__gallery--fullscreen')) {
        closeGallery()
      } else {
        openGallery()
      }
    })
  })

  const productZoomClose = document.querySelector('.product__gallery-close')
  productZoomClose.addEventListener('click', function () {
    closeGallery()
  })

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (productGallery.classList.contains('product__gallery--fullscreen')) {
        closeGallery()
      }
    }
  })
}

const absorbentButtons = document.querySelectorAll('.product__absorbent-button')

absorbentButtons.forEach((item) => {
  item.addEventListener('click', function () {
    const activeButton = document.querySelector(
      '.product__absorbent-button--active'
    )
    if (activeButton) {
      activeButton.classList.remove('product__absorbent-button--active')
    }

    const activeText = document.querySelector(
      '.product__absorbent-text--active'
    )
    if (activeText) {
      activeText.classList.remove('product__absorbent-text--active')
    }

    item.classList.add('product__absorbent-button--active')
    const text = document.getElementById(item.getAttribute('data-target'))
    text.classList.add('product__absorbent-text--active')
  })
})
